import { render, staticRenderFns } from "./teamStyle.vue?vue&type=template&id=0a3d7140&scoped=true"
import script from "./teamStyle.vue?vue&type=script&lang=js"
export * from "./teamStyle.vue?vue&type=script&lang=js"
import style0 from "./teamStyle.vue?vue&type=style&index=0&id=0a3d7140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d7140",
  null
  
)

export default component.exports